import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import UserDefinedFieldModel from '../../../models/UserDefinedFieldModel';
import DataService from "../../../services/data.service";
import { IdProps } from '../../../types/IdProps';
import AddUserDefinedFiedSelectlistOptionPopup from '../Popups/UserDefinedField_popup_AddSelectListItem';
import EditUserDefinedFiedSelectlistOptionPopup from '../Popups/UserDefinedField_popup_EditSelectListItem';

interface IProps {
    userDefinedField: UserDefinedFieldModel
}

const UserDefinedField_tab_SelectListItems: React.FC<IProps> = ({ userDefinedField }) => {
    const [data, setData] = useState<[]>();
    const [showAddPopup, setShowAddPopup] = useState<boolean>(false)
    const [showEditPopup, setShowEditPopup] = useState<boolean>(false)
    const [selectedId, setSelectedId] = useState(0)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [userDefinedField.id]);

    function getTableData() {
        DataService.get<[]>('api/v1/UserDefinedFieldSelectListItems/ByUserDefinedField/' + userDefinedField.id)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function editRow(rowData) {
        setSelectedId(rowData.id)
        setShowEditPopup(true)
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/UserDefinedFieldSelectListItems/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    let colInfos: IColInfo[] = [
        { key: true, dataProp: 'Id', visible: false },
        { title: 'Value', dataProp: 'value' },
        { title: 'Text', dataProp: 'text' },
        { title: 'SortOrder', dataProp: 'sortOrder', dataType: 'number', sort: 'asc' },
        { title: 'IsActive', dataProp: 'isActive', dataType: 'bool'  },
        { title: 'Product categories', dataProp: 'productCategories' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.EditUdf)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowAddPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtUserDefinedFieldSelectListItems'
                colInfos={colInfos}
                tableData={data}
                onRowClick={editRow} 
            />
            {showAddPopup && <AddUserDefinedFiedSelectlistOptionPopup show={showAddPopup} onHide={() => { setShowAddPopup(false); getTableData(); }} userDefinedFieldId={userDefinedField.id} userDefinedFieldTypeId={userDefinedField.userDefinedFieldTypeId} />}
            {showEditPopup && <EditUserDefinedFiedSelectlistOptionPopup show={showEditPopup} onHide={() => { setShowEditPopup(false); getTableData(); }} userDefinedFieldSelectlistOptionId={selectedId} userDefinedFieldTypeId={userDefinedField.userDefinedFieldTypeId} />}
        </>
    );
}
export default UserDefinedField_tab_SelectListItems;